<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Software:</label>
        <div>
          <model-select
            :options="softwareOptions"
            v-model="editSoftware"
            placeholder="Software"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>License #:</label>
        <div>
          <input type="text" placeholder="License" v-model="editLicense" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Summary:</label>
        <div>
          <input type="text" placeholder="Summary" v-model="editSummary" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >Add Software</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  props: ["submitLoading", "software"],
  components: {
    ModelSelect,
    spinnerButton,
  },
  watch: {
    software: function () {
      this.initSoftwareOptions();
    },
  },
  mounted() {
    this.initSoftwareOptions();
  },
  data() {
    return {
      editSoftware: null,
      editLicense: null,
      editSummary: null,
      softwareOptions: [],
    };
  },
  methods: {
    initSoftwareOptions: function () {
      this.softwareOptions = (this.software || []).map((item) => ({
        text: item.name,
        value: item.id,
      }));
    },
    buttonClick: function () {
      if (!this.editSoftware) {
        this.$toasted.global.toast_error({ message: "select a software" });
        return;
      }
      const softwareData = this.software.find(
        (item) => item.id === this.editSoftware
      );
      const data = {
        logo: softwareData.logo,
        name: softwareData.name,
        price: softwareData.price,
        license: this.editLicense,
        summary: this.editSummary,
      };
      this.$emit("buttonClick", data);
    },
  },
};
</script>
